import { all } from "redux-saga/effects";
import {
  distributorProfileWatcher,
  distributerEditWatcher,
  forgetPasswordWatcher,
  loginWatcher,
  logoutWatcher,
  portalLoginWatcher,
  resetPasswordWatcher,
  signupWatcher,
  verifyEmailWatcher,
  distributerLogoUpldWatcher,
  createNewPasswordWatcher,
} from "./authSaga";
import { faqListWatcher } from "./faqSaga";
import {
  cityListWatcher,
  districtListWatcher,
  pincodeAutoListWatcher,
  stateListWatcher,
} from "./commonSaga";
import {
  contactDetailsWorker,
  registerDetailsWatcher,
  uploadDrugLicenceWatcher,
  uploadGstWatcher,
} from "./onBoardingSaga";
import {
  CFAOrderListWatcher,
  CFAupdateInvoiceWatcher,
  companyListWatcher,
  currentOrderListWatcher,
  exportReconciliationWatcher,
  getProfileInfoWatcher,
  orderDetailWatcher,
  orderHistoryListWatcher,
  orderRemarksReasonListWatcher,
  supplyOrderCFAWatcher,
  supplyOrderDetailWatcher,
  updateInvoiceWatcher,
  updateOrderStatusWatcher,
  uploadInvoiceWatcher,
} from "./orderSaga";
import { supportCreateWatcher } from "./supportSaga";
import { notificationsListWatcher } from "./notificationSaga";

export default function* rootSaga() {
  yield all([
    loginWatcher(),
    signupWatcher(),
    forgetPasswordWatcher(),
    logoutWatcher(),
    verifyEmailWatcher(),
    resetPasswordWatcher(),
    uploadDrugLicenceWatcher(),
    registerDetailsWatcher(),
    uploadGstWatcher(),
    contactDetailsWorker(),
    getProfileInfoWatcher(),
    currentOrderListWatcher(),
    orderHistoryListWatcher(),
    orderDetailWatcher(),
    updateOrderStatusWatcher(),
    uploadInvoiceWatcher(),
    updateInvoiceWatcher(),
    stateListWatcher(),
    districtListWatcher(),
    cityListWatcher(),
    faqListWatcher(),
    supportCreateWatcher(),
    exportReconciliationWatcher(),
    companyListWatcher(),
    portalLoginWatcher(),
    distributorProfileWatcher(),
    distributerEditWatcher(),
    distributerLogoUpldWatcher(),
    CFAOrderListWatcher(),
    supplyOrderCFAWatcher(),
    supplyOrderDetailWatcher(),
    CFAupdateInvoiceWatcher(),
    orderRemarksReasonListWatcher(),
    createNewPasswordWatcher(),
    pincodeAutoListWatcher(),
    notificationsListWatcher(),
  ]);
}
